import React, { useEffect, useState } from "react";
import Topbar from "../Topbar/Topbar";
import "./CustomerReport.css";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    tooltip: {
      mode: "index",
      intersect: false,
    },
  },
  tension: 0.4,
  elements: {
    line: {
      tension: 0.4,
      borderWidth: 2,
    },
    point: {
      radius: function (context) {
        // Show a dot only for every 5th data point
        const index = context.dataIndex;
        return index % 5 === 0 ? 3 : 0;
      },
      hoverRadius: 5,
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: {
        autoSkip: true,
        maxTicksLimit: 10, // Show only some labels to prevent crowding
      },
    },
    y: {
      grid: {
        display: false,
      },
      beginAtZero: true,
    },
  },
  interaction: {
    mode: "nearest",
    axis: "x",
    intersect: false,
  },
};

const CustomerReport = () => {
  const staffId = useSelector((state) => state.id);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 7); // Format: "YYYY-MM"
  });

  const [complaintCount, setComplaintCount] = useState({
    open: 0,
    completed: 0,
  });
  const [enquiryCount, setEnquiryCount] = useState({ open: 0, completed: 0 });
  const [installationCount, setInstallationCount] = useState({
    open: 0,
    completed: 0,
  });
  const [duesCount, setDuesCount] = useState({ open: 0, completed: 0 });

  const [complaintsData, setComplaintsData] = useState({
    labels: [],
    datasets: [],
  });

  const [installationData, setInstallationData] = useState({
    labels: [],
    datasets: [],
  });
  const [duesData, setDuesData] = useState({ labels: [], datasets: [] });
  const [enquiryData, setEnquiryData] = useState({
    labels: [],
    datasets: [],
  });
  //Complaint

  useEffect(() => {
    const generateLabels = (monthStr) => {
      const [year, month] = monthStr.split("-").map(Number);
      const labelDays = [1, 5, 10, 15, 20, 25];

      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", {
            month: "short",
          })
          .toUpperCase()} ${lastDay}`
      );

      return labels;
    };

    const updatedLabels = generateLabels(selectedMonth);

    setComplaintsData((prevData) => ({
      ...prevData,
      labels: updatedLabels,
    }));
  }, [selectedMonth]);
  //Installation

  useEffect(() => {
    const generateLabels = (monthStr) => {
      const [year, month] = monthStr.split("-").map(Number);
      const labelDays = [1, 5, 10, 15, 20, 25];

      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase()} ${lastDay}`
      );

      return labels;
    };

    const updatedLabels = generateLabels(selectedMonth);

    setInstallationData((prevData) => ({
      ...prevData,
      labels: updatedLabels,
    }));
  }, [selectedMonth]);
  //Dues

  useEffect(() => {
    const generateLabels = (monthStr) => {
      const [year, month] = monthStr.split("-").map(Number);
      const labelDays = [1, 5, 10, 15, 20, 25];

      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase()} ${lastDay}`
      );

      return labels;
    };

    const updatedLabels = generateLabels(selectedMonth);

    setDuesData((prevData) => ({
      ...prevData,
      labels: updatedLabels,
    }));
  }, [selectedMonth]);

  //Recovery

  useEffect(() => {
    const generateLabels = (monthStr) => {
      const [year, month] = monthStr.split("-").map(Number);
      const labelDays = [1, 5, 10, 15, 20, 25];

      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase()} ${lastDay}`
      );

      return labels;
    };

    const updatedLabels = generateLabels(selectedMonth);

    setEnquiryData((prevData) => ({
      ...prevData,
      labels: updatedLabels,
    }));
  }, [selectedMonth]);

  //backend integration

  useEffect(() => {
    const fetchStatusSummary = async () => {
      try {
        const [year, month] = selectedMonth.split("-");
        const response = await axios.get(
          `${apiUrl}/monthly-report?year=${year}&month=${month}`
        );

        const summary = response.data;
        const yearInt = parseInt(year);
        const monthInt = parseInt(month) - 1;

        // Generate labels for ALL days in the month
        const lastDay = new Date(yearInt, monthInt + 1, 0).getDate();
        const labels = Array.from({ length: lastDay }, (_, i) => {
          const day = i + 1;
          const date = new Date(yearInt, monthInt, day);
          const monthAbbr = date
            .toLocaleString("en-US", { month: "short" })
            .toUpperCase();
          return `${monthAbbr} ${String(day).padStart(2, "0")}`;
        });

        const formatDateMap = (list) =>
          list.reduce((acc, item) => {
            const d = new Date(item.date);
            const day = d.getDate();
            const label = `${d
              .toLocaleString("en-US", {
                month: "short",
              })
              .toUpperCase()} ${String(day).padStart(2, "0")}`;
            acc[day] = item.count; // Now using day number as key for easier mapping
            return acc;
          }, {});

        const generateChartData = (title, color1, color2, data) => {
          const openMap = formatDateMap(data.open || []);
          const completedMap = formatDateMap(data.completed || []);

          // Create data for ALL days in month
          const openData = Array.from({ length: lastDay }, (_, i) => {
            return openMap[i + 1] || 0;
          });
          const completedData = Array.from({ length: lastDay }, (_, i) => {
            return completedMap[i + 1] || 0;
          });

          return {
            labels,
            datasets: [
              {
                label: "Open",
                data: openData,
                borderColor: color1,
                backgroundColor: "#1fbd61ff",
                pointBorderColor: "black",
                pointBackgroundColor: "black",
                borderWidth: 3,
              },
              {
                label: "Completed",
                data: completedData,
                borderColor: color2,
                backgroundColor: `${color2}33`,
                pointBorderColor: "black",
                pointBackgroundColor: "black",
                borderWidth: 3,
              },
            ],
          };
        };

        // Set chart data
        setComplaintsData(
          generateChartData(
            "Complaint",
            "#1fbd61ff",
            "#0497FF",
            summary.complaint
          )
        );
        setInstallationData(
          generateChartData(
            "Installation",
            "#1fbd61ff",
            "#F1C40F",
            summary.installation
          )
        );
        setDuesData(
          generateChartData("Due", "#1fbd61ff", "#FF6B6D", summary.due)
        );
        setEnquiryData(
          generateChartData("Enquiry", "#1fbd61ff", "#B57CFF", summary.enquiry)
        );

        // Set total counts (unchanged)
        const getTotalCount = (list = []) =>
          list.reduce((total, item) => total + item.count, 0);

        setComplaintCount({
          open: getTotalCount(summary.complaint?.open),
          completed: getTotalCount(summary.complaint?.completed),
        });

        setEnquiryCount({
          open: getTotalCount(summary.enquiry?.open),
          completed: getTotalCount(summary.enquiry?.completed),
        });

        setInstallationCount({
          open: getTotalCount(summary.installation?.open),
          completed: getTotalCount(summary.installation?.completed),
        });

        setDuesCount({
          open: getTotalCount(summary.due?.open),
          completed: getTotalCount(summary.due?.completed),
        });
      } catch (error) {
        console.error("Failed to fetch status summary:", error);
      }
    };

    if (selectedMonth && staffId) {
      fetchStatusSummary();
    }
  }, [selectedMonth, staffId, apiUrl]);

  return (
    <Container className="ms-3 me-3">
      <Topbar />
      <div className="row">
        <h3 className="">Complaints Report</h3>
        <Row className="mt-4">
          <Col md={3}>
            <div className="col-md-2 col-sm-12 ms-5">
              <div>
                <input
                  type="month"
                  value={selectedMonth}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value) {
                      // If cleared, reset to current month
                      const current = new Date().toISOString().slice(0, 7);
                      setSelectedMonth(current);
                    } else {
                      setSelectedMonth(value);
                    }
                  }}
                />
              </div>
            </div>
          </Col>
          {/* <Col md={3}>
            <div className="cr-generate">
              <button className="cr-generate-btn">Generate</button>
            </div>
          </Col> */}
          <Col>
            {/* <button className="black-btn cr-export">Export</button> */}
          </Col>
        </Row>
      </div>

      <Row className="mt-5">
        <Col md={6} sm={12}>
          <div className="complaints-report-box">
            <h4>Complaints Report</h4>
            <Line data={complaintsData} options={options} />
            <div
              style={{ textAlign: "center", fontSize: "18px", marginTop: 10 }}
            >
              <span style={{ color: "#1fbd61ff", fontWeight: "bold" }}>
                Open: {complaintCount.open}
              </span>
              &nbsp;&nbsp;
              <span style={{ color: "#0497FF", fontWeight: "bold" }}>
                Solved: {complaintCount.completed}
              </span>
            </div>
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className="connections-report-box">
            <h4>Installation Report</h4>
            <Line data={installationData} options={options} />
            <div
              style={{ textAlign: "center", fontSize: "18px", marginTop: 10 }}
            >
              <span style={{ color: "#1fbd61ff", fontWeight: "bold" }}>
                Open: {installationCount.open}
              </span>
              &nbsp;&nbsp;
              <span style={{ color: "#F1C40F", fontWeight: "bold" }}>
                Completed: {installationCount.completed}
              </span>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={6} sm={12}>
          <div className="dues-report-box">
            <h4>Dues Report</h4>
            <Line data={duesData} options={options} />
            <div
              style={{ textAlign: "center", fontSize: "18px", marginTop: 10 }}
            >
              <span style={{ color: "#1fbd61ff", fontWeight: "bold" }}>
                Open: {duesCount.open}
              </span>
              &nbsp;&nbsp;
              <span style={{ color: "#FF6B6D", fontWeight: "bold" }}>
                Closed: {duesCount.completed}
              </span>
            </div>
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className="leads-report-box">
            <h4>Enquiry Report</h4>
            <Line data={enquiryData} options={options} />
            <div
              style={{ textAlign: "center", fontSize: "18px", marginTop: 10 }}
            >
              <span style={{ color: "#1fbd61ff", fontWeight: "bold" }}>
                Open: {enquiryCount.open}
              </span>
              &nbsp;&nbsp;
              <span style={{ color: "#B57CFF", fontWeight: "bold" }}>
                Completed: {enquiryCount.completed}
              </span>
            </div>
          </div>
        </Col>
      </Row>

      <br />
    </Container>
  );
};

export default CustomerReport;
